<app-bar-chart-date
  i18n-header
  i18n-yNameRight
  header="Purchase Invoices"
  yKey="value"
  xKey="invoiceDate"
  yKeyRight="numberOfInvoices"
  yNameRight="Number of Invoices"
  [service]="chartWeeksPurchaseInvoicesService"
  [xRotation]="xRotation"
  [yName]="yNamePurchaseValue"
  [id]="supplierId"
  [barChartPeriod]="barChartPeriod"
>
</app-bar-chart-date>
